import Units from "./units"

export { Units }

const units = window.Units || new Units()
window.Units = units

export default units
